import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Chip,
  TextField,
  Autocomplete,
} from '@mui/material';
import propTypes from 'prop-types';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';

const InsuranceSelectorModal = ({
  open,
  onClose,
  onSave,
  initialIncludedInsurances,
  organizationId,
}) => {
  const firestore = useFirestore();
  const [insurances, setInsurances] = useState([]);
  const [includedInsurances, setIncludedInsurances] = useState(
    initialIncludedInsurances?.insurancesToValidate || [],
  );

  const handleInsuranceSelect = (event, value) => {
    if (value) {
      const insurance = {
        id: value.id,
        sigla: value.name,
      };
      setIncludedInsurances([...includedInsurances, insurance]);
    }
  };

  const handleRemoveInsurance = (insurance) => {
    setIncludedInsurances(includedInsurances.filter((i) => i.id !== insurance.id) || []);
  };

  const handleSave = () => {
    onSave(includedInsurances);
  };

  useEffect(() => {
    if (open && insurances.length === 0) {
      firestore
        .collection(collections.configurations)
        .where('name', '==', 'API')
        .where('organizationId', '==', organizationId)
        .get()
        .then((res) => {
          if (!res.empty) {
            const configAPI = res.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setInsurances(
              configAPI[0]?.obrassociales?.sort((a, b) => (a?.name < b?.name ? -1 : 1)) || [],
            ); // Guardamos las configuraciones en el estado
          }
        })
        .catch((error) => {
          console.error('Error fetching API configurations: ', error);
        });
    }
  }, [open, insurances]);

  const availableInsurances = insurances?.filter(
    (insurance) => !includedInsurances.some((excluded) => excluded.id === insurance.id),
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Seleccionar las obras sociales a incluir en la validación</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, mt: 1 }}>
          <Autocomplete
            options={availableInsurances}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} label="Seleccione una obra social" />}
            onChange={handleInsuranceSelect}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            fullWidth
          />
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {includedInsurances.map((insurance) => (
            <Chip
              key={insurance.id}
              label={insurance.sigla}
              onDelete={() => handleRemoveInsurance(insurance)}
              deleteIcon={16}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setIncludedInsurances(initialIncludedInsurances?.insurancesToValidate || []);
            onClose();
          }}
        >
          Cancelar
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Props = {
  open: propTypes.bool,
  onClose: propTypes.bool,
  onSave: propTypes.func,
  initialIncludedInsurances: propTypes.object,
  organizationId: propTypes.string.isRequired,
};

InsuranceSelectorModal.propTypes = Props;

export default InsuranceSelectorModal;
